import React from 'react';

const BulletSparkIcon = ({ className = '' }) => (
  <img
    src="/manual-booking/icons/feature-sparkle.png"
    alt=""
    width="12"
    height="12"
    className={className}
    aria-hidden="true"
  />
);

export default BulletSparkIcon;
